/* ==========================================================================
   Blindbox Collection Board
   Filterleiste für /collections/blindbox — Verfügbarkeit, Serie, Hersteller.

   Warum clientseitig und nicht über Shopify-Facetten:
   Die Produktdaten tragen die Serie nicht. `vendor` ist bei der Mehrheit
   "animeboy", `productType` ist meist leer und die Tags sind uneinheitlich.
   Die Titel folgen dagegen zuverlässig dem Muster "Serie – Hersteller/Reihe
   – Bl\n   – Blindbox". Serie und Hersteller werden deshalb aus dem Titel abgeleitet,
   genauso wie es kuji-collection-board.js für die Kuji-Serien tut.

   Kernprinzip (wie bei Kuji): Karten werden NIE aus #product-grid entfernt,
   nur per Klasse markiert und über CSS `order` sortiert. Sonst brechen
   Load-More, der Filter-Drawer und die Section-Render-Sortierung des Themes.
   ========================================================================== */

(function () {
  'use strict';

  var ALL = '__all__';

  /* Reihenfolge = Priorität. Der erste Treffer gewinnt, deshalb stehen
     Serien vor Marken-Reihen: "The Monsters x One Piece" ist One Piece. */
  var SERIES = [
    { label: 'One Piece', re: /one\s*piece/ },
    { label: 'Naruto', re: /naruto/ },
    { label: 'Pokémon', re: /pok[eé]mon/ },
    { label: 'Demon Slayer', re: /demon\s*slayer|kimetsu/ },
    { label: 'Jujutsu Kaisen', re: /jujutsu/ },
    { label: 'SpongeBob', re: /spongebob|schwammkopf|bikini\s*bottom/ },
    { label: 'Haikyu!!', re: /haikyu/ },
    { label: 'Digimon', re: /digimon/ },
    { label: 'Detective Conan', re: /detective\s*conan|conan/ },
    { label: 'Hunter × Hunter', re: /hunter\s*[×x]\s*hunter/ },
    { label: 'Yu-Gi-Oh!', re: /yu-?gi-?oh/ },
    { label: "JoJo's Bizarre Adventure", re: /jojo/ },
    { label: 'Frieren', re: /frieren/ },
    { label: 'Inuyasha', re: /inuyasha/ },
    { label: 'My Hero Academia', re: /my\s*hero\s*academia/ },
    { label: 'Die Tagebücher der Apothekerin', re: /apothekerin/ },
    { label: 'The Monsters', re: /the\s*monsters/ }
  ];

  var BRANDS = [
    { label: 'Pop Mart', re: /pop\s*mart|popmart/ },
    { label: 'Top Toy', re: /top\s*toy|toptoy/ },
    { label: 'Funko', re: /funko|mystery\s*minis/ },
    { label: 'EAKI', re: /eaki/ },
    { label: 'DesQ', re: /desq/ },
    { label: 'Mighty Jaxx', re: /freeny|hidden\s*dissectibles/ },
    { label: 'Bandai', re: /bandai/ },
    { label: 'Funism', re: /funism/ },
    { label: 'GONG', re: /gong/ },
    { label: 'Kwistal', re: /kwistal/ },
    { label: 'Cosbi', re: /cosbi/ },
    { label: 'Plabako', re: /plabako/ }
  ];

  function match(list, haystack) {
    for (var i = 0; i < list.length; i++) {
      if (list[i].re.test(haystack)) return list[i].label;
    }
    return '';
  }

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn, { once: true });
    } else {
      fn();
    }
  }

  function Board(tools) {
    this.tools = tools;
    this.board = tools.querySelector('[data-bbx-board]');
    this.grid = document.getElementById('product-grid');
    /* Nicht document.querySelector('.collection') — die subcollections-Section
       bringt einen eigenen .collection-Container mit und steht im DOM davor.
       Die Leiste landete dadurch über den Kategorie-Kacheln statt über dem Grid. */
    this.collection = this.grid ? this.grid.closest('.collection') : null;
    this.view = 'live';
    this.serie = ALL;
    this.brand = ALL;
    this.items = [];
    this.labels = {
      allSeries: tools.getAttribute('data-all-series-label') || 'Alle Serien',
      allBrands: tools.getAttribute('data-all-brands-label') || 'Alle Hersteller',
      empty: tools.getAttribute('data-empty-text') || 'Dazu haben wir gerade keine Blindbox.',
      reset: tools.getAttribute('data-reset-label') || 'Filter zurücksetzen'
    };
  }

  Board.prototype.init = function () {
    if (!this.board || !this.grid || !this.collection) return;

    this.scan();
    if (!this.items.length) return;

    document.documentElement.classList.add('bbx-on');
    this.mount();
    this.buildSelects();
    this.bind();
    this.apply();
  };

  /* Karten einlesen. Verfügbarkeit kommt aus .price--sold-out — das setzt
     das Theme serverseitig und ist damit verlässlicher als ein Badge-Text. */
  Board.prototype.scan = function () {
    var kids = this.grid.children;
    this.items = [];

    for (var i = 0; i < kids.length; i++) {
      var el = kids[i];
      if (!el.classList || !el.classList.contains('grid-item')) continue;

      var link = el.querySelector('a[href*="/products/"]');
      var heading = el.querySelector('.card-heading');
      var title = (heading ? heading.textContent : link ? link.textContent : '') || '';
      title = title.replace(/\s+/g, ' ').trim();
      if (!title) continue;

      var hay = title.toLowerCase();
      var sold = !!el.querySelector('.price--sold-out, .badge.sold-out');

      el.classList.toggle('bbx-item--sold', sold);

      this.items.push({
        el: el,
        sold: sold,
        serie: match(SERIES, hay),
        brand: match(BRANDS, hay)
      });
    }
  };

  /* Die Leiste muss in .collection hängen, damit sie über der ganzen
     Grid-Höhe kleben kann. Die Tools-Section selbst ist dafür zu niedrig. */
  Board.prototype.mount = function () {
    var wrap = document.createElement('div');
    wrap.className = 'bbx-sticky';
    if (this.tools.getAttribute('data-sticky') === 'true') {
      wrap.classList.add('is-sticky');
    }

    var anchor = this.grid;
    while (anchor && anchor.parentElement !== this.collection) {
      anchor = anchor.parentElement;
    }

    wrap.appendChild(this.board);
    this.board.hidden = false;

    if (anchor) {
      this.collection.insertBefore(wrap, anchor);
    } else {
      this.collection.insertBefore(wrap, this.collection.firstChild);
    }

    this.empty = document.createElement('li');
    this.empty.className = 'bbx-empty';
    this.empty.hidden = true;
    this.empty.innerHTML =
      '<p class="bbx-empty__text"></p>' +
      '<button type="button" class="bbx-empty__btn"></button>';
    this.empty.querySelector('.bbx-empty__text').textContent = this.labels.empty;
    this.empty.querySelector('.bbx-empty__btn').textContent = this.labels.reset;
    this.grid.appendChild(this.empty);
  };

  /* Optionen aus dem tatsächlichen Bestand — nie eine leere Serie anbieten */
  Board.prototype.options = function (key, allLabel) {
    var counts = {};
    var order = key === 'serie' ? SERIES : BRANDS;

    this.items.forEach(function (item) {
      var v = item[key];
      if (!v) return;
      counts[v] = (counts[v] || 0) + 1;
    });

    var out = [{ value: ALL, text: allLabel, n: this.items.length }];
    order.forEach(function (entry) {
      if (counts[entry.label]) {
        out.push({ value: entry.label, text: entry.label, n: counts[entry.label] });
      }
    });
    return out;
  };

  Board.prototype.buildSelects = function () {
    var self = this;

    [
      { key: 'serie', all: this.labels.allSeries },
      { key: 'brand', all: this.labels.allBrands }
    ].forEach(function (cfg) {
      var root = self.board.querySelector('[data-bbx-select="' + cfg.key + '"]');
      if (!root) return;

      var panel = root.querySelector('[data-bbx-select-panel]');
      var opts = self.options(cfg.key, cfg.all);

      /* Nur ein Eintrag heißt: es gibt nichts zu filtern */
      if (opts.length < 2) {
        root.hidden = true;
        return;
      }

      panel.innerHTML = '';
      opts.forEach(function (opt) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'bbx-opt' + (opt.value === ALL ? ' is-active' : '');
        btn.setAttribute('role', 'option');
        btn.setAttribute('data-value', opt.value);
        btn.setAttribute('aria-selected', opt.value === ALL ? 'true' : 'false');
        btn.innerHTML =
          '<span class="bbx-opt__text"></span><span class="bbx-opt__n"></span>';
        btn.querySelector('.bbx-opt__text').textContent = opt.text;
        btn.querySelector('.bbx-opt__n').textContent = opt.n;
        panel.appendChild(btn);
      });
    });
  };

  Board.prototype.closeSelects = function (except) {
    var list = this.board.querySelectorAll('[data-bbx-select]');
    for (var i = 0; i < list.length; i++) {
      if (list[i] === except) continue;
      list[i].classList.remove('is-open');
      var t = list[i].querySelector('[data-bbx-select-toggle]');
      var p = list[i].querySelector('[data-bbx-select-panel]');
      if (t) t.setAttribute('aria-expanded', 'false');
      if (p) p.hidden = true;
    }
  };

  Board.prototype.bind = function () {
    var self = this;

    this.board.addEventListener('click', function (e) {
      var seg = e.target.closest('[data-bbx-view]');
      if (seg) {
        self.view = seg.getAttribute('data-bbx-view');
        self.board.querySelectorAll('[data-bbx-view]').forEach(function (b) {
          var on = b === seg;
          b.classList.toggle('is-active', on);
          b.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        self.apply();
        return;
      }

      var toggle = e.target.closest('[data-bbx-select-toggle]');
      if (toggle) {
        var root = toggle.closest('[data-bbx-select]');
        var panel = root.querySelector('[data-bbx-select-panel]');
        var open = !root.classList.contains('is-open');
        self.closeSelects(root);
        root.classList.toggle('is-open', open);
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        panel.hidden = !open;
        return;
      }

      var opt = e.target.closest('.bbx-opt');
      if (opt) {
        var host = opt.closest('[data-bbx-select]');
        var key = host.getAttribute('data-bbx-select');
        self[key] = opt.getAttribute('data-value');

        host.querySelectorAll('.bbx-opt').forEach(function (o) {
          var on = o === opt;
          o.classList.toggle('is-active', on);
          o.setAttribute('aria-selected', on ? 'true' : 'false');
        });

        var label = host.querySelector('[data-bbx-select-label]');
        if (label) label.textContent = opt.querySelector('.bbx-opt__text').textContent;
        host.classList.toggle('is-filtered', self[key] !== ALL);

        self.closeSelects(null);
        self.apply();
      }
    });

    this.empty.addEventListener('click', function (e) {
      if (!e.target.closest('.bbx-empty__btn')) return;
      self.reset();
    });

    document.addEventListener('click', function (e) {
      if (!self.board.contains(e.target)) self.closeSelects(null);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') self.closeSelects(null);
    });
  };

  Board.prototype.reset = function () {
    this.serie = ALL;
    this.brand = ALL;

    var self = this;
    this.board.querySelectorAll('[data-bbx-select]').forEach(function (host) {
      var key = host.getAttribute('data-bbx-select');
      var all = key === 'serie' ? self.labels.allSeries : self.labels.allBrands;
      host.classList.remove('is-filtered');
      var label = host.querySelector('[data-bbx-select-label]');
      if (label) label.textContent = all;
      host.querySelectorAll('.bbx-opt').forEach(function (o) {
        var on = o.getAttribute('data-value') === ALL;
        o.classList.toggle('is-active', on);
        o.setAttribute('aria-selected', on ? 'true' : 'false');
      });
    });

    this.apply();
  };

  Board.prototype.apply = function () {
    var self = this;
    var shown = 0;
    var liveTotal = 0;

    this.items.forEach(function (item) {
      if (!item.sold) liveTotal++;

      var ok =
        (self.view === 'all' || !item.sold) &&
        (self.serie === ALL || item.serie === self.serie) &&
        (self.brand === ALL || item.brand === self.brand);

      item.el.classList.toggle('bbx-hidden', !ok);
      if (ok) shown++;
    });

    this.empty.hidden = shown > 0;

    var live = this.board.querySelector('[data-bbx-count-live]');
    var all = this.board.querySelector('[data-bbx-count-all]');
    if (live) live.textContent = liveTotal;
    if (all) all.textContent = this.items.length;
  };

  ready(function () {
    var tools = document.querySelector('[data-bbx-tools]');
    if (tools) new Board(tools).init();
  });
})();